import { ClienteDto, InfoAzienda } from "@api/client";
import { companyUpdateCompany } from "common/_redux/company/actions";
import { companyDetailsSelector } from "common/_redux/company/selectors";
import BftButton from "common/components/button";
import BftCodeInput from "common/components/code-input";
import BtfOptionGroup from "common/components/option-button";
import BftRadioGroup from "common/components/radio-button";
import { presentaAziendaSchema } from "common/validators/validators";
import { tipoClienteOptions, tipoCodiceOptions } from "constants/options";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { Formik } from "formik";
import React from "react";

interface Props {
	onComplete: () => void;
}

const PresentaAzienda: React.FC<Props> = (props) => {
	const { onComplete } = props;

	const dispatch = useAppDispatch();

	const companyDetails = useAppSelector(companyDetailsSelector);

	const handleSubmit = (values: InitialValues) => {
		let request: ClienteDto = {
			...companyDetails,
			infoAzienda: {
				...values,
				// codiceFiscale: values.tipoCodice == "CF" ? values.codiceFiscale : undefined,
				// partitaIva: values.tipoCodice == "PIVA" ? values.partitaIva : undefined,
				codiceFiscale: values.codiceFiscale,
				partitaIva: values.partitaIva,
			},
		};

		dispatch(companyUpdateCompany(request))
			.unwrap()
			.then((res) => {
				if (res) {
					onComplete();
				}
			});
	};

	return (
		<Formik
			initialValues={
				{
					tipoCliente: companyDetails?.infoAzienda?.tipoCliente || "PersonaFisica",
					tipoCodice: "PIVA",
					partitaIva: companyDetails?.infoAzienda?.partitaIva || undefined,
					codiceFiscale: companyDetails?.infoAzienda?.codiceFiscale || undefined,
				} as InitialValues
			}
			onSubmit={handleSubmit}
			validationSchema={presentaAziendaSchema}
			enableReinitialize
			validateOnMount
		>
			{({ values, isValid, handleChange, handleSubmit: _handleSubmit }) => {
				const _handleChange = (propertyName: keyof InitialValues, value: string) => {
					if (propertyName == "tipoCliente") {
						handleChange("tipoCodice")("PIVA");
					}

					// if (propertyName == "codiceFiscale") handleChange("partitaIva")("");
					// if (propertyName == "partitaIva") handleChange("codiceFiscale")("");

					handleChange(propertyName)(value);
				};

				return (
					<form onSubmit={_handleSubmit}>
						<BftRadioGroup
							controlId="inquadramentoFiscale"
							label="Inquadramento fiscale"
							options={tipoClienteOptions}
							onChange={(e) => _handleChange("tipoCliente", e.currentTarget.value)}
							selectedOption={values?.tipoCliente}
						/>

						{values?.tipoCliente === "PersonaFisica" && (
							<div className="col-12">
								<div className="container mb-3">
									<span className="font-weight-bold m-0">Nota:</span>
									<span className="gray m-0 ms-2">
										<small>Inserisci la partita iva e/o il codice fiscale</small>
									</span>
								</div>
								<div className="ms-4">
									<BtfOptionGroup
										controlId="tipoCodice"
										options={tipoCodiceOptions}
										onChange={(e) => _handleChange("tipoCodice", e.currentTarget.value)}
										selectedOption={values?.tipoCodice}
									/>
								</div>
							</div>
						)}

						{values?.tipoCliente && (
							<>
								{values?.tipoCodice === "CF" ? (
									<BftCodeInput
										length={16}
										id="codiceFiscale"
										key={"codiceFiscale"}
										pattern={"^([A-Za-z0-9]{1,})$"}
										placeholder={"Codice Fiscale*"}
										codeHandler={(code) => _handleChange("codiceFiscale", code)}
										inputCode={values?.codiceFiscale}
										inputRequired={true}
									/>
								) : (
									<BftCodeInput
										length={11}
										id="partitaIva"
										key={"partitaIva"}
										pattern={"^([0-9]{1,})$"}
										placeholder={"Partita IVA*"}
										codeHandler={(code) => _handleChange("partitaIva", code)}
										inputCode={values?.partitaIva}
										capitalize={true}
									/>
								)}
							</>
						)}

						<div className="mx-2 my-4">
							<BftButton type="submit" className="btn-buffetti col-12" isDisabled={!isValid}>
								Avanti
							</BftButton>
						</div>
					</form>
				);
			}}
		</Formik>
	);
};

export default PresentaAzienda;

interface InitialValues extends InfoAzienda {
	tipoCodice: "PIVA" | "CF" | undefined;
}
